import React, { useState, useEffect } from 'react'
import { Modal, Input, InputNumber, Button, List } from 'antd'
import axios from 'axios'
import { useAuth } from '../../../../context/auth'
import { toast } from 'react-toastify'

const UserAddErShopItem = ({ id, isModalVisible, hideModal, onItemAdded }) => {
  const [auth] = useAuth()
  const userId = auth?.user?._id
  const [searchTerm, setSearchTerm] = useState('')
  const [quantity, setQuantity] = useState(1)
  const [remark, setRemark] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [selectedItem, setSelectedItem] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const fetchItems = async () => {
      if (searchTerm.length < 3) {
        setSearchResults([])
        return
      }

      try {
        const { data } = await axios.get(
          '/api/v1/user/stock-check/add-item-box/search',
          { params: { query: searchTerm } }
        )
        setSearchResults(data)
      } catch (error) {
        console.error('Search error:', error)
      }
    }

    const delayDebounce = setTimeout(() => {
      if (!selectedItem) fetchItems()
    }, 300)

    return () => clearTimeout(delayDebounce)
  }, [searchTerm, selectedItem])

  const handleItemSelect = (item) => {
    setSelectedItem(item)
    setSearchTerm(`${item.itemCode} - ${item.description}`)
    setSearchResults([])
  }

  const handleSubmit = async () => {
    setIsSubmitting(true)
    try {
      const { data } = await axios.post(
        '/api/v1/user/stock-check/add-ershop-item',
        {
          id,
          itemId: selectedItem._id,
          quantity,
          userId,
          remark,
        }
      )

      const item = {
        ...data.item,
        lastUptByCode: auth?.user?.code,
      }

      if (onItemAdded) onItemAdded(item)

      toast.success(data.message || 'Item added successfully')

      hideModal()
      setSearchTerm('')
      setSelectedItem(null)
      setQuantity(1)
      setRemark('')
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message)
      } else {
        toast.error('Failed to add item.')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal
      title='Add Item to Box'
      open={isModalVisible}
      onCancel={() => {
        hideModal()
        setSelectedItem(null)
        setSearchTerm('')
        setQuantity(1)
      }}
      footer={null}
      width='50%'
    >
      <div className='mb-3'>
        <label className='form-label fw-bold'>Search Item name or code</label>
        <div style={{ display: 'flex' }}>
          <Input
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value)
              setSelectedItem(null)
            }}
            disabled={!!selectedItem}
            style={{
              flex: 1,
              backgroundColor: '#fff',
              color: selectedItem ? '#000' : 'inherit',
              cursor: selectedItem ? 'not-allowed' : 'text',
            }}
          />

          <Button
            onClick={() => {
              setSearchTerm('')
              setSelectedItem(null)
              setSearchResults([])
            }}
            disabled={!searchTerm}
          >
            Clear
          </Button>
        </div>

        {searchResults.length > 0 && !selectedItem && (
          <List
            bordered
            size='small'
            dataSource={searchResults}
            renderItem={(item) => (
              <List.Item
                onClick={() => handleItemSelect(item)}
                style={{ cursor: 'pointer' }}
              >
                {item.itemCode} - {item.description}
              </List.Item>
            )}
            className='mt-2'
          />
        )}
      </div>

      <div className='mb-3'>
        <label className='form-label fw-bold'>Quantity</label>
        <InputNumber
          min={1}
          value={quantity}
          onChange={(value) => setQuantity(value)}
          style={{ width: '100%' }}
        />
      </div>

      <div className='mb-3'>
        <label className='form-label fw-bold'>Remark</label>
        <Input value={remark} onChange={(e) => setRemark(e.target.value)} />
      </div>

      <div className='d-flex justify-content-end'>
        <button
          type='button'
          className='btn btn-success me-3'
          onClick={handleSubmit}
          disabled={!selectedItem || isSubmitting || !(Number(quantity) > 0)}
        >
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>

        <button
          type='button'
          className='btn btn-secondary'
          onClick={() => {
            hideModal()
            setSearchTerm('')
            setQuantity(1)
            setSelectedItem(null)
            setRemark('')
          }}
        >
          Cancel
        </button>
      </div>
    </Modal>
  )
}

export default UserAddErShopItem
